/** @jsxImportSource @emotion/react */

import { fabric } from 'fabric';

import { useLingui } from '@lingui/react/macro';
import { ALargeSmall } from 'lucide-react';
import { useSelector } from 'react-redux';
import customization from 'modules/overlay-canvas/addons/customization';
import history from 'modules/overlay-canvas/addons/history';
import SnapToGrid from 'modules/overlay-canvas/addons/snap-to-grid';
import { DEFAULT_FONT_STACK } from 'shared/fonts';
import UDIconButton from 'ud-ui/components/icon-button';
import UDTippy from 'ud-ui/components/tippy';
import { selectActiveModal } from 'modules/template-editor/store/editor/selectors';
import { useEditorManager } from 'modules/template-editor/ui/context';

export function AddText() {
  const { t } = useLingui();
  const activeModal = useSelector(selectActiveModal);
  const fabricManager = useEditorManager();

  const addText = (text: string) => {
    if (!fabricManager) return;
    history.saveState();
    const { left, top } = fabricManager.getLeftTopCurVP();

    const textBox = new fabric.Textbox(text, {
      fontSize: 20,
      fontFamily: DEFAULT_FONT_STACK,
      left,
      top,
      strokeLineJoin: 'round',
      strokeWidth: 0,
      fontWeight: 'normal',
      fill: '#000000FF',
      ...customization.getAllProperties(),
    });

    textBox.on('editing:exited', () => {
      if (textBox.text !== undefined && textBox.text.replace(/\s+/g, ' ').trim() !== '') return;
      fabricManager.canvas.remove(textBox);
    });

    fabricManager.canvas.add(textBox);
    SnapToGrid.snapToGrid([textBox]);
  };

  const onClickAddText = () => {
    if (!fabricManager) return;
    // eslint-disable-next-line lingui/no-unlocalized-strings -- текст нового объекта канвы сохраняется в табло, это контент шаблона
    addText('Новый текст');
  };

  return (
    <UDTippy disabled={Boolean(activeModal)} content={t`Текст`} size="xs">
      <span style={{ display: 'inline-block' }}>
        <UDIconButton variant="ghost" icon={<ALargeSmall size={20} strokeWidth={1.5} />} onClick={onClickAddText} tabIndex={0} />
      </span>
    </UDTippy>
  );
}
